export function formatSecondsCompact(seconds: number): string {
  const value = Math.max(0, Math.trunc(seconds));
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const secs = value % 60;
  return `${hours}h ${minutes}m ${secs}s`;
}

export function getRemainingSeconds(startAt: string, durationSeconds: number, nowMs = Date.now()): number {
  const startMs = new Date(startAt).getTime();
  if (!Number.isFinite(startMs)) {
    return Math.max(0, Math.trunc(durationSeconds));
  }

  const elapsedSeconds = Math.max(0, Math.floor((nowMs - startMs) / 1000));
  return Math.max(0, Math.trunc(durationSeconds) - elapsedSeconds);
}

const relativeFormatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

export function formatRelativeTime(input: string | number | Date, nowMs = Date.now()): string {
  const targetMs =
    typeof input === "number" ? input : input instanceof Date ? input.getTime() : new Date(input).getTime();

  if (!Number.isFinite(targetMs)) {
    return "unknown";
  }

  const diffSeconds = Math.round((targetMs - nowMs) / 1000);
  const absSeconds = Math.abs(diffSeconds);

  if (absSeconds < 60) {
    return "just now";
  }

  if (absSeconds < 60 * 60) {
    return relativeFormatter.format(Math.round(diffSeconds / 60), "minute");
  }

  if (absSeconds < 24 * 60 * 60) {
    return relativeFormatter.format(Math.round(diffSeconds / 3600), "hour");
  }

  if (absSeconds < 7 * 24 * 60 * 60) {
    return relativeFormatter.format(Math.round(diffSeconds / (24 * 60 * 60)), "day");
  }

  return relativeFormatter.format(Math.round(diffSeconds / (7 * 24 * 60 * 60)), "week");
}
